"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASTParserFacade = void 0;
const acorn = __importStar(require("acorn"));
const chalk_1 = __importDefault(require("chalk"));
class ASTParserFacade {
    static parse(sourceCode, config) {
        const sourceTypeLength = ASTParserFacade.sourceTypes.length;
        for (let i = 0; i < sourceTypeLength; i++) {
            try {
                return ASTParserFacade.parseType(sourceCode, config, ASTParserFacade.sourceTypes[i]);
            }
            catch (error) {
                if (i < sourceTypeLength - 1) {
                    continue;
                }
                throw new Error(ASTParserFacade.processParsingError(sourceCode, error.message, error.loc));
            }
        }
        throw new Error('Acorn parsing error');
    }
    static parseType(sourceCode, inputConfig, sourceType) {
        const comments = [];
        const config = {
            ...inputConfig,
            allowAwaitOutsideFunction: true,
            onComment: comments,
            sourceType
        };
        const program = acorn
            .parse(sourceCode, config);
        if (comments.length) {
            program.comments = comments;
        }
        return program;
    }
    static processParsingError(sourceCode, errorMessage, position) {
        const isMissingLocationData = !(position === null || position === void 0 ? void 0 : position.line) || !position.column;
        if (isMissingLocationData) {
            throw new Error(errorMessage);
        }
        const sourceCodeLines = sourceCode.split(/\r?\n/);
        const errorLine = sourceCodeLines[position.line - 1];
        if (!errorLine) {
            throw new Error(errorMessage);
        }
        const startErrorIndex = Math.max(0, position.column - ASTParserFacade.nearestSymbolsCount);
        const endErrorIndex = Math.min(errorLine.length, position.column + ASTParserFacade.nearestSymbolsCount);
        const formattedPointer = ASTParserFacade.colorError('>');
        const formattedCodeSlice = `...${errorLine.slice(startErrorIndex, endErrorIndex).replace(/^\s+/, '')}...`;
        throw new Error(`ERROR at line ${position.line}: ${errorMessage}\n${formattedPointer} ${formattedCodeSlice}`);
    }
}
exports.ASTParserFacade = ASTParserFacade;
ASTParserFacade.colorError = chalk_1.default.red;
ASTParserFacade.nearestSymbolsCount = 15;
ASTParserFacade.sourceTypes = [
    'script',
    'module'
];
